export default __webpack_public_path__ + "static/correo_icon-13600666f9ba9ae6cb0650ca27bace0d.png";